<template>
  <v-row v-if="commentText" class="text-center mb-2">
      <v-col>
      <span class="bold">{{ $t("forms.show.reject.info") }}</span>
      <v-btn class="ml-2" x-small color="error" @click.stop="rejectDialog = true">
        {{$t('button.see.comment')}}
      </v-btn>
      <v-dialog v-model="rejectDialog" max-width="650">
        <v-card>
          <v-card-title class="headline">{{
            $t("forms.show.reject.comment")
          }}</v-card-title>

          <v-card-text>
            <v-textarea
              v-model="commentText"
              required
              outlined
              hide-details
              readonly
            ></v-textarea>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="rejectDialog = false">
              {{ $t("button.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    rejectDialog: false
  }),
  props: {
    commentText: String
  }
};
</script>

<style scoped></style>
